module.exports = __webpack_public_path__ + "img/kyc-pp.d20478c1.svg";